import { Box, Link, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

import { AGENT_HELP_ADDRESS } from "@consts/index";

interface NonRenewalExistsModalProps {
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
}

export function NonRenewalExistsModal({
  isModalOpen,
  onClose,
}: NonRenewalExistsModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      title="Non-Renewal Exists"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography variant="h5" sx={{ pr: 5, textAlign: "justify" }}>
        This policy has already been marked for non-renewal. This action cannot
        be completed.
        <br />
        Please contact{" "}
        <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
          {AGENT_HELP_ADDRESS}
        </Link>{" "}
        for assistance.
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
}
